import { createTheme } from "@mui/material/styles";
import Colour from "./Colour";
let saved = localStorage.getItem("Theme");
saved = saved != "undefined" && saved !== null ? JSON.parse(saved) : null;
let Colors = saved != "undefined" && saved !== null ? saved : Colour.Purple;
document.documentElement.style.setProperty(
  "--main-bg-color",
  Colors?.tableBGColor
);
let mode = Colors?.tmId?.toString().includes("9") ? "dark" : "light" || "light";

export let Themefn = (e) => {
  let tmId = e;
  for (let key in Colour) {
    if (Colour[key].tmId == tmId) {
      localStorage.setItem("Theme", JSON.stringify(Colour[key]));
      // window.location.reload();
    }
  }
};
export function getThemeMode() {
  // Example logic to get the mode
  const savedMode = localStorage.getItem("Theme");
  if (savedMode === "dark" || savedMode === "light") {
    return savedMode;
  }

  // Default to light mode if no saved mode is found
  return (mode = Colors?.tmId?.toString().includes("9")
    ? "dark"
    : "light" || "light");
}
export const ThemeObj = (id) => {
  return {
    palette: {
      // mode: Colors?.tmId.toString().includes("9") ? "dark" : "light",
      mode: mode,
      TmId: {
        id: Colors?.tmId,
      },
      primary: {
        main: Colors?.primary,
        black: Colors?.black,
      },
      secondary: {
        main: Colors?.secondary,
      },
      tertiary: {
        main: Colors?.tertiary,
      },
      // forth: {
      //   main: Colors.forth,
      // },
      success: {
        main: Colors?.success,
      },
      danger: {
        main: Colors?.danger,
      },
      background: {
        paper: Colors?.papperBg,
        bgpaper: Colors?.light,
        tablebg: Colors?.tableBGColor,
        tablebg1: Colors?.tableBGColor1,
        tablebg2: Colors?.tableBGColor2,
      },
      input: {
        font: Colors?.inputFieldColor,
        border: Colors?.inputFieldBorderColor,
        label: Colors?.inputLabelColor,
      },
      shadow: {
        primary: Colors?.shadow1,
        secondary: Colors?.shadow2,
        tertiary: Colors?.shadow3,
      },
      bodyGray: {
        main: Colors?.bodyGray2,
        secondary: Colors?.bodyGray1,
        tertiary: Colors?.bodyGray,
      },
      primaryRowClr: {
        main: Colors?.primaryRow,
        secondary: Colors?.activeRow,
      },
      sideBar: {
        main: Colors?.sideBar1,
        secondary: Colors?.sideBarIcon,
      },
      nav: {
        main: Colors?.nav,
        font: Colors?.navF,
      },
      text: {
        mainHead: "1rem",
        head: "20px",
        para: "14px",
        discr: "10px",
        disable: "#DDDDDD",
        Link: Colors.linkClr,
        textClr: Colors.FontClr == undefined ? Colors?.navF : Colors.FontClr,
      },
    },
    typography: {
      allVariants: {
        fontSize: "14px",
        // color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
      },
      h1: {
        fontFamily: "Milliard Bold",
        fontSize: "18px",
        fontWeight: "bolder",
      },
      h3: {
        fontFamily: "Milliard Bold",
        fontSize: "14px",
        color: "white",
      },
      body1: {
        fontSize: "1rem",
      },
    },
    components: {
      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor:
              Colors?.bodyGray2 == undefined
                ? Colors?.bodyGray
                : Colors?.bodyGray2,
            maxHeight: "300px", // Set maximum height for all Popovers
            overflowY: "auto", // Enable vertical scrolling
            "&:hover::-webkit-scrollbar": {
              border: "1px solid",
              borderColor:
                Colors?.bodyGray2 == undefined
                  ? Colors?.bodyGray
                  : Colors?.bodyGray2,
            },
            "&:hover::-webkit-scrollbar-thumb": {
              border: "1px solid",
              borderColor:
                Colors?.bodyGray2 == undefined
                  ? Colors?.bodyGray
                  : Colors?.bodyGray2,
            },
            "&::-webkit-scrollbar": {
              width: "8px",
              transition: "width 0.3s ease",
            },
            "&::-webkit-scrollbar-track": {
              background:
                Colors?.bodyGray2 == undefined
                  ? Colors?.bodyGray
                  : Colors?.bodyGray2,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: Colors?.primary,
              border: "3px solid",
              borderColor:
                Colors?.bodyGray2 == undefined
                  ? Colors?.bodyGray
                  : Colors?.bodyGray2,
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            // This ensures that any other Paper component also respects this color
            backgroundColor: Colors?.papperBg,
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableRipple: true,
          disableElevation: true,
        },
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.variant === "contained" &&
              ownerState.color === "primary" && {
                color: "#fff",
              }),
          }),
          contained: {
            "&:focus": {
              boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
            },
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            "& .MuiTableRow-root": {
              // color: "#595C66", // Change font color of TableRow inside TableHead
            },
            "& .MuiTableCell-root": {
              // color: "#595C66", // Ensure font color is applied to TableCell as well
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontSize: "16px",
            fontWeight: "bold",
          },
          body: {
            fontSize: "14px",
            // color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
          },
        },
      },
      MuiTablePagination: {
        styleOverrides: {
          select: {
            // Global styles for the dropdown
            padding: "6px 10px", // Adjust padding
            borderRadius: "4px", // Add border radius
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          root: {
            // color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
            "&.Mui-disabled": {
              color: "gray", // Change the color of disabled icons in the select component
            },
          },
          toolbar: {
            "& .MuiTablePagination-actions": {
              // color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
              "&.Mui-disabled": {
                color: "gray", // Change the color of disabled icons in the select component
              },
            },
          },
          selectIcon: {
            // color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
            "&.Mui-disabled": {
              color: "gray", // Change the color of disabled icons in the select component
            },
          },
        },
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            // background: Colors?.tableBGColor,
            "&:hover": {
              color: Colors?.primary, // Global hover color
            },
            "&.Mui-active": {
              // background: Colors?.tableBGColor,
              color: Colors?.primary, // Change this to your desired active color
            },
          },
        },
      },
      MuiIconButton: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiRadio: {
        defaultProps: {
          disableRipple: true,
        },
        styleOverrides: {
          root: {
            padding: "0px",
            margin: "0px 5px",
            color: "#e2e4ee",
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          // disableRipple: true,
        },
        styleOverrides: {
          root: {
            color: "#919191",
            // '&.Mui-checked': {
            //   color: '#34994f',
            // },
            // '&.Mui-disabled': {
            //   color: '#e2e4ee',
            // },
            // '&.Mui-checked.Mui-disabled': {
            //   color: '#e2e4ee',
            // },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            // color: "black",
            fontSize: "12px",
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#f0f0f0", // Background color on focus
              },
            },
          },
          input: {
            fontSize: "16px",
            // color: "red", // Set the font size for input text
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          InputProps: {
            classes: {
              input: "custom-scrollbar", // Your custom class
            },
          },
        },
        styleOverrides: {
          input: {
            fontSize: "12px",
            // color: Colors.FontClr == undefined ? "black" : Colors.FontClr
          },
          root: {
            "& .Mui-disabled .MuiInputLabel-root": {
              color: "rgba(0, 0, 0, 0.2)", // Label color when disabled
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-disabled": {
                color: "rgba(0, 0, 0, 0.2)", // Text color when disabled
              },
            },
            "& .MuiInputBase-root": {
              // backgroundColor: '#22272b', // Change background color of the input
            },
            "& .MuiInputBase-input": {
              color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
            },
            "& .MuiInputLabel-root": {
              color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: Colors.FontClr == undefined ? "black" : Colors.FontClr,
            },
            "&.Mui-focused": {
              backgroundColor: "#ffb74d !important", // Set background color when focused for all TextFields
            },
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#ffb74d", // Background color on focus
              },
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#ffb74d", // Background color on focus
              },
            },
          },
          select: {
            height: "25px",
            padding: "4.5px 14px", // Adjust padding to maintain proper spacing
            minHeight: "unset", // Ensure min-height is not overriding the height
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#ffb74d", // Background color on focus
              },
            },
          },
          popper: {
            // zIndex: 1200,
          },
          paper: {
            // zIndex: 1200,
            backgroundColor:
              Colors?.bodyGray2 == undefined
                ? Colors?.bodyGray
                : Colors?.bodyGray2,
          },
          listbox: {
            // zIndex: 1200,
            backgroundColor:
              Colors?.bodyGray2 == undefined
                ? Colors?.bodyGray
                : Colors?.bodyGray2,
          },
          input: {
            fontSize: "13px", // Set the font size for input text in outlined variant
          },
          inputRoot: {
            height: "34px",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent", // If you don't want a border on focus
            },
            "&.Mui-focused": {
              backgroundColor: "#ffb74d", // Your desired focus background color
            },
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#ffb74d", // Background color on focus
              },
            },
          },
          input: {
            fontSize: "12px", // Set the font size for input text in outlined variant
            // color: "#919191",
            // color: "black",
            // paddingRight: "50px",
          },
          notchedOutline: {
            borderColor: "gray",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#ffb74d", // Background color on focus
              },
            },
          },
          asterisk: {
            color: "red", // Change this to your desired color
          },
          outlined: {
            // Specific for the outlined variant
            fontSize: "14px", // Set the font size for the label (placeholder when not focused)
            // color: "black",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              "&:focus-within": {
                backgroundColor: "#ffb74d", // Background color on focus
              },
            },
          },
          input: {
            "&::placeholder": {
              fontSize: "16px", // Set the font size for the placeholder
              opacity: 1, // Make sure the placeholder is fully visible
            },
          },
        },
      },
    },
    // zIndex: {
    //   drawer: 1302,
    // }

    // below code represents the break points that can have intaed of xs(0), sm(600), md(900), lg(1200), xl(1536)
    // breakpoints : {
    //     values : {
    //         mobile : 0,
    //         tablet : 768,
    //         laptop : 1024,
    //         desktop : 1200
    //     }
    // }
  };
};
// const Theme = () => {
//   const modes = useSelector(
//     (state) => state.userPrefrenceandReducer?.userPreference?.find(elem => elem.AttributeTypeCD == 'SelectedTheme').AttributeValue
//   );
//   // const theme1 = useMemo(() => getTheme(modes), [mode]);
//   return createTheme(ThemeObj(modes))
// };
let theme = createTheme(ThemeObj());

export default theme;
